<template>
  <el-container class="register-page">
    <el-main
      :style="{ backgroundImage: `url(${img.url})` }"
      style="padding: 0 0 0 0 !important"
    >
      <img :src="banner" v-if="banner != ''" style="width: 100%" />
      <div class="main" ref="main">
        <el-form
          v-if="personalForm.show"
          :model="ruleForm"
          :rules="rulesPersonal"
          ref="personalForm"
          label-width="150px"
          style="overflow: auto"
          class="ms-content"
        >
          <el-form-item label-width="0px">
            <h2>{{ $t("register.info") }}</h2>
          </el-form-item>
          <el-form-item v-if="page > 0" label-width="0">
            <h3>{{ $t("register.person") + "(" + page + ")" }}</h3>
          </el-form-item>
          <el-form-item label-width="500px" :label="$t('register.word')">
            <el-select
              class="lang"
              v-model="ruleForm.lang"
              @change="selectLang()"
              placeholder="语言/語言/Language"
              size="mini"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option> </el-select
          ></el-form-item>
          <!-- <el-form-item
            prop="keyword"
            :label="$t('register.keyword')"
            class="el-item-wrap"
          >
            <el-input
              @keyup.enter.native="logName"
              clearable
              v-model="keyword"
              :placeholder="$t('register.keyword')"
              @change="change"
              class="wx-el-input"
            ></el-input>
          </el-form-item> -->
          <el-form-item
            prop="documentTypeId"
            :label="$t('register.documentTypeId')"
          >
            <el-select
              ref="idCard"
              style="width: 100%"
              v-model="ruleForm.documentTypeId"
              :placeholder="
                $t('register.input') + $t('register.documentTypeId')
              "
            >
              <el-option
                v-for="(type, index) in DocumentType"
                :label="type.name"
                :key="index"
                :value="type.documentTypeId"
                >{{ type.name }}
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="idCard" :label="$t('register.idCard')">
            <el-input
              clearable
              ref="idCard"
              v-model="ruleForm.idCard"
              :placeholder="$t('register.input') + $t('register.idCard')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="label" :label="$t('register.label')">
            <el-input
              clearable
              ref="openId"
              v-model="ruleForm.openId"
              :placeholder="$t('register.input') + $t('register.label')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="name" :label="$t('register.name')">
            <el-input
              clearable
              ref="name"
              v-model="ruleForm.name"
              :placeholder="$t('register.input') + $t('register.name')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="phoneNo" :label="$t('register.phoneNo')">
            <el-input
              clearable
              v-model="ruleForm.phone"
              :placeholder="$t('register.input') + $t('register.phoneNo')"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="page == 0"
            prop="company"
            :label="$t('register.company')"
          >
            <el-input
              clearable
              v-model="ruleForm.company"
              @input="clearRule('companyEn')"
              :placeholder="$t('register.input') + $t('register.company')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="position" :label="$t('register.position')">
            <el-input
              clearable
              v-model="ruleForm.position"
              :placeholder="$t('register.input') + $t('register.position')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="countryArea" :label="$t('register.countryArea')">
            <el-autocomplete
              style="width: 100%"
              clearable
              v-model="ruleForm.countryArea"
              :fetch-suggestions="querySearch"
              :placeholder="$t('register.countryArea')"
              @select="handleSelect"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label-width="0px">
            <el-card
              class="box-card"
              v-for="(item, j) in ruleForm.list"
              v-if="
                (item.input == 'match' ||
                  item.input == 'forums' ||
                  (item.type == 0 && match)) &&
                page > 0
              "
            >
              <div slot="header" class="clearfix">
                <span style="color: red" v-show="item.required == 1">*</span>
                <span v-html="item.title"></span>
              </div>
              <div style="padding: 5px" v-for="(option, i) in item.values">
                <div v-if="item.type == 2">
                  <el-radio
                    :checked="option.checked"
                    v-model="item.validator"
                    border="border"
                    size="medium"
                    @change="(checked) => checkRow(checked, item, option)"
                    :label="option.value"
                    ><p v-html="option.value"></p
                  ></el-radio>
                </div>
                <div v-if="item.type == 0 && match">
                  <el-checkbox
                    :checked="option.checked"
                    @change="(checked) => checkRow(checked, item, option)"
                    border="border"
                    size="medium"
                    ><p v-html="option.value"></p
                  ></el-checkbox>
                </div>
              </div>
            </el-card>
          </el-form-item>
          <el-form-item label-width="0px">
            <el-button
              class="prev"
              size="medium"
              type="primary"
              @click="clear('personalForm')"
              >{{ $t("register.clear") }}</el-button
            >
            <el-button
              class="next"
              size="medium"
              type="primary"
              v-loading="personalForm.loading"
              @click="submitForm('personalForm')"
              >{{ $t("register.print") }}</el-button
            >
          </el-form-item>
        </el-form>
        <el-form
          v-if="elseForm.show"
          :model="ruleForm"
          ref="elseForm"
          class="ms-content"
        >
          <el-form-item label-width="0px">
            <h2>{{ $t("register.info") }}</h2>
          </el-form-item>
          <p style="padding: 5px">
            {{ $t("register.tip") }} “ <span style="color: red">✓</span>”
          </p>
          <el-card
            class="box-card"
            v-for="(item, j) in ruleForm.list"
            v-if="
              (item.input == 'persons' && persons) ||
              (item.input != 'persons' && item.type != 0) ||
              (item.type == 0 && match)
            "
          >
            <div
              v-if="
                (item.type == 0 && item.values.length > 0) || item.type != 0
              "
              slot="header"
              class="clearfix"
            >
              <span style="color: red" v-show="item.required == 1">*</span>
              <span style="white-space: normal">{{ item.title }}</span>
            </div>
            <div style="white-space: normal" v-else v-html="item.title"></div>
            <div
              v-if="item.values.length > 0"
              style="padding: 5px"
              v-for="(option, i) in item.values"
            >
              <div v-if="item.type == 0">
                <el-checkbox
                  :checked="option.checked"
                  @change="(checked) => checkRow(checked, item, option)"
                  border="border"
                  size="medium"
                  ><p v-html="option.value"></p
                ></el-checkbox>
              </div>
              <div v-if="item.type == 4">
                <el-checkbox
                  :checked="option.checked"
                  @change="(checked) => checkRow(checked, item, option)"
                  border="border"
                  size="medium"
                  ><p v-html="option.value"></p
                ></el-checkbox>
                <el-input
                  clearable
                  v-model="item.validator"
                  v-if="i == item.values.length - 1"
                  :placeholder="option.value"
                ></el-input>
              </div>
              <div v-else-if="item.type == 2">
                <el-radio
                  :checked="option.checked"
                  v-model="item.validator"
                  border="border"
                  size="medium"
                  @change="(checked) => checkRow(checked, item, option)"
                  :label="option.value"
                  ><p v-html="option.value"></p
                ></el-radio>
              </div>
            </div>
            <div style="padding: 5px" v-if="item.type == 8">
              <el-input-number
                type="number"
                size="medium"
                v-model="item.validator"
                controls-position="right"
                style="width: 100%"
                :min="1"
                :max="9"
                :placeholder="$t('register.input') + item.title"
              ></el-input-number>
            </div>
          </el-card>
          <el-form-item label-width="0px"></el-form-item>
          <el-form-item label-width="0px">
            <el-button
              class="prev"
              size="medium"
              type="primary"
              @click="prev('personalForm')"
              >{{ $t("register.prev") }}</el-button
            >
            <el-button
              class="next"
              size="medium"
              v-loading="elseForm.loading"
              type="primary"
              @click="submitForm('elseForm')"
              >{{ $t("register.next") }}</el-button
            >
          </el-form-item>
        </el-form>
        <el-form
          v-if="confirmForm.show"
          ref="confirmForm"
          :model="ruleForm"
          label-width="140px"
          style="overflow: auto"
          class="ms-content"
        >
          <el-form-item
            label-width="0px"
            style="color: #fff; background-color: #6e9c35"
          >
            &nbsp;&nbsp;{{ $t("register.confirm") }}
          </el-form-item>
          <div v-for="(option, i) in personalList">
            <el-form-item label-width="0">
              <h3 v-if="i > 0">
                <img
                  style="width: 24px; margin-bottom: -6px; margin-right: 6px"
                  src="../assets/img/person.png"
                />{{ $t("register.person") + "(" + i + ")" }}
              </h3>
              <el-link
                style="float: right; padding-left: 10px"
                type="primary"
                @click="selectPage(option, i)"
                >{{ $t("register.update") }}</el-link
              >
              <!-- <el-link  v-if="i>0" style="float:right" type="primary" @click="deletePage(option,i)">{{$t('register.remove')}}</el-link> -->
            </el-form-item>
            <el-form-item prop="name" :label="$t('register.name')">
              <el-input
                disabled
                ref="name"
                v-model="option.name"
                :placeholder="$t('register.input') + $t('register.name')"
              ></el-input>
            </el-form-item>
            <el-form-item prop="sex" :label="$t('register.sex')">
              <el-select
                style="width: 100%"
                disabled
                v-model="option.sex"
                :placeholder="$t('register.input') + $t('register.sex')"
              >
                <el-option
                  v-for="(option, i) in sexs"
                  :value="option.value"
                  :label="option.label"
                ></el-option>
              </el-select>
              <i slot="prepend" icon="el-icon-user"></i>
            </el-form-item>
            <el-form-item
              v-if="page == 0"
              prop="company"
              :label="$t('register.company')"
            >
              <el-input
                disabled
                v-model="option.company"
                @input="clearRule('companyEn')"
                :placeholder="$t('register.input') + $t('register.company')"
              ></el-input>
            </el-form-item>
            <el-form-item
              v-if="page == 0"
              prop="companyEn"
              :label="$t('register.companyEn')"
            >
              <el-input
                disabled
                @input="clearRule('company')"
                v-model="option.companyEn"
              ></el-input>
            </el-form-item>
            <el-form-item prop="position" :label="$t('register.position')">
              <el-input disabled v-model="option.position"></el-input>
            </el-form-item>
            <el-form-item prop="address1" :label="$t('register.address1')">
              <el-input disabled v-model="option.address1"></el-input>
            </el-form-item>
            <el-form-item prop="postcode" :label="$t('register.postcode')">
              <el-input disabled v-model="option.postcode"></el-input>
            </el-form-item>
            <el-form-item prop="telNo" :label="$t('register.telNo')">
              <el-input disabled v-model="option.telNo"></el-input>
            </el-form-item>
            <el-form-item prop="faxNo" :label="$t('register.faxNo')">
              <el-input disabled v-model="option.faxNo"></el-input>
            </el-form-item>
            <el-form-item prop="email" :label="$t('register.email')">
              <el-input
                type="email"
                disabled
                v-model="option.email"
                :placeholder="$t('register.input') + $t('register.email')"
              ></el-input>
            </el-form-item>
            <el-form-item prop="webSite" :label="$t('register.webSite')">
              <el-input disabled v-model="option.webSite"></el-input>
            </el-form-item>
          </div>
          <el-form-item label-width="0px">
            <el-button
              class="prev"
              size="medium"
              v-loading="confirmForm.loading"
              type="primary"
              @click="prev('elseForm')"
              >{{ $t("register.prev") }}</el-button
            >
            <el-button
              class="next"
              size="medium"
              type="primary"
              v-loading="confirmForm.loading"
              @click="submitForm('confirmForm')"
              >{{ $t("register.submit") }}</el-button
            >
          </el-form-item>
        </el-form>
        <el-form
          v-if="qrcodeForm.show && bannerMoblie == ''"
          ref="qrcodeForm"
          label-width="0px"
          class="ms-content"
        >
          <div>
            <el-form-item>
              <p>{{ $t("register.qrcode") }}</p>
            </el-form-item>
            <el-card class="box-card" style="text-align: center">
              <h3>{{ ruleForm.name }}</h3>
              <h5>&nbsp;</h5>
              <h3>{{ ruleForm.company }}</h3>
              <p>&nbsp;</p>
              <div>
                <img
                  style="width: 280px"
                  v-if="qrcodeForm.show"
                  id="qrcode"
                  :src="qrcodeForm.qrcode"
                />
              </div>
            </el-card>
            <p>&nbsp;</p>
          </div>
        </el-form>
      </div>
    </el-main>
  </el-container>
</template>
<script>
//import countryCodeSelector from "vue-country-code-selector";
//import { regionData, CodeToText } from "element-china-area-data";
import area from "../assets/json/area.json";
import areas from "../assets/json/allarea.json";
import allarea from "../assets/json/all.json";
import allChs from "../assets/json/all_chs.json";
import { Loading } from "element-ui";
import QRCode from "qrcodejs2";
import axios from "axios";
//let pinyin = require("js-pinyin");
export default {
  inject: ["reloadPage"],
  name: "register",
  // components: {
  //   countryCodeSelector,
  // },
  data: function () {
    return {
      img: {
        url: require("../assets/img/bg.png"),
        bg: require("../assets/img/info.png"),
      },
      DocumentType: [],
      allarea: [],
      restaurants: [],
      persons: false,
      keyword: "",
      match: false,
      //areaOptions: regionData,
      page: 0,
      total: 0,
      arr: areas,
      count: 60,
      timer: null,
      prov: "",
      city: "",
      district: "",
      cityArr: [],
      districtArr: [],
      isDisabled: false,
      selectedOptions: [],
      sexs: [],
      phone: "",
      list: [],
      personalList: [],
      upload: false,
      flag: false,
      width: 200,
      url: "",
      banner: "",
      bannerMoblie: "",
      options: [
        { value: "zh", label: "中文简体" },
        { value: "chs", label: "中文繁體" },
        { value: "en", label: "English" },
      ],
      ruleForm: {
        documentTypeId: "",
        personalId: "",
        projectId: localStorage.getItem("project_Id"),
        registerId: "",
        type: 0,
        area: 853,
        country: "",
        name: "",
        sex: "",
        company: "",
        companyEn: "",
        postcode: "",
        countryArea: "",
        city: "",
        province: "",
        address1: "",
        address2: "",
        address: "",
        position: "",
        telNo: "",
        phoneNo: "",
        faxNo: "",
        idCard: "",
        email: "",
        webSite: "",
        lang: localStorage.lang,
        loading: false,
        phone: "",
        code: "",
        disabled: 0,
        show: true,
        list: [],
      },
      cardForm: {
        show: false,
        card: false,
      },
      personalForm: {
        show: true,
        loading: false,
      },
      elseForm: {
        loading: false,
        show: false,
      },
      confirmForm: {
        loading: false,
        show: false,
      },
      qrcodeForm: { show: false, qrcode: "" },
      rules: null,
      rulesPersonal: null,
      rulesElse: {},
    };
  },
  methods: {
    getDocumentType() {
      this.$axios
        .get("/DocumentType/Project/" + this.ruleForm.projectId)
        .then((res) => {
          if (res.data.hasError == false) {
            this.DocumentType = [...res.data.data];
          }
        });
    },
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      // localStorage.setItem('isiphone',flag)
      console.log(flag);
      return flag;
    },
    validateComapny(rule, value, callback) {
      if (this.ruleForm.company == "" && this.ruleForm.companyEn == "") {
        callback(
          new Error(
            this.$t("register.input") +
              this.$t("register.company") +
              "/" +
              this.$t("register.input") +
              this.$t("register.companyEn")
          )
        );
      } else {
        callback();
      }
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      cb(results);
    },
    provinceSearch(queryString, cb) {
      let restaurants = this.allarea.filter((item) => {
        return item.parent == this.ruleForm.area.toString();
      });
      let results = queryString
        ? restaurants.filter(this.areaFilter(queryString))
        : restaurants;
      cb(results);
    },
    citySearch(queryString, cb) {
      let restaurants = this.allarea.filter((item) => {
        return item.parent == this.prov.toString();
      });
      let results = queryString
        ? restaurants.filter(this.areaFilter(queryString))
        : restaurants;
      cb(results);
    },
    areaFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    provinceSelect(item) {
      this.ruleForm.province = item.name;
      this.prov = item.value;
    },
    citySelect(item) {
      this.ruleForm.city = item.name;
      this.city = item.value;
    },
    handleCountryArea(e) {
      localStorage.countryArea = e;
    },
    handlePhone(e) {
      localStorage.phone = e;
    },
    handleCode(e) {
      localStorage.code = e;
    },
    handleSelect(item) {
      try {
        if (this.ruleForm.area && this.ruleForm.phoneNo) {
          this.ruleForm.faxNo = this.ruleForm.faxNo.replace(
            "+" + this.ruleForm.area,
            "+" + item.code
          );
          this.ruleForm.phoneNo = this.ruleForm.phoneNo.replace(
            "+" + this.ruleForm.area,
            "+" + item.code
          );
          this.ruleForm.telNo = this.ruleForm.telNo.replace(
            "+" + this.ruleForm.area,
            "+" + item.code
          );
        } else {
          this.ruleForm.faxNo = "+" + item.code;
          this.ruleForm.phoneNo = "+" + item.code;
          this.ruleForm.telNo = "+" + item.code;
        }
      } catch (error) {}
      this.ruleForm.area = item.code;
      this.prov = item.value;
      this.ruleForm.countryArea = item.value;
      localStorage.countryArea = item.value;
      localStorage.area = item.code;
    },
    selectPage(option, i) {
      this.ruleForm = option;
      this.page = i;
      this.confirmForm.show = false;
      this.personalForm.show = true;
      this.hangleGoUp();
    },
    deletePage(option, i) {
      this.personalList.splice(i, 1);
    },
    changeProv(o) {
      this.ruleForm.countryArea = o;
    },
    changeCity(o) {
      this.ruleForm.province = o;
    },
    changeDistrict(o) {
      this.ruleForm.city = o;
    },
    provBlur(e) {
      this.prov = e.target.value;
      this.ruleForm.countryArea = e.target.value;
    },
    cityBlur(e) {
      this.city = e.target.value;
      this.ruleForm.province = e.target.value;
    },
    districtBlur(e) {
      this.district = e.target.value;
      this.ruleForm.city = e.target.value;
    },
    updateCity() {
      for (var i in this.arr) {
        var obj = this.arr[i];
        if (obj.name == this.prov) {
          this.cityArr = obj.sub;
          break;
        }
      }
      if (this.cityArr.length > 0) {
        this.city = this.cityArr[0].name;
      }
    },
    updateDistrict() {
      for (var i in this.cityArr) {
        var obj = this.cityArr[i];
        if (obj) {
          if (obj.name == this.city) {
            this.districtArr = obj.sub;
            break;
          }
        }
      }
      if (
        this.districtArr &&
        this.districtArr.length > 0 &&
        this.districtArr[0].name
      ) {
        this.district = this.districtArr[0].name;
      } else {
        this.district = "";
      }
    },
    clearRule(obj) {
      this.$refs.personalForm.clearValidate(obj);
    },
    handleChange() {
      for (let i = 0; i < this.selectedOptions.length; i++) {
        if (i == 0) {
          this.ruleForm.province = CodeToText[this.selectedOptions[i]];
        } else if (i == 1) {
          this.ruleForm.city = CodeToText[this.selectedOptions[i]];
        } else {
          this.ruleForm.address1 =
            CodeToText[this.selectedOptions[i]] + this.ruleForm.address1;
        }
      }
    },
    changeElseRemark(val, item, option, j) {
      option.checked = true;
    },
    checkRow(checked, item, option) {
      if (item.input == "registers") {
        if (localStorage.lang == "en") {
          this.persons = option.value == "Yes";
        } else {
          this.persons = option.value == "是";
        }
      }
      if (item.input == "forums") {
        if (localStorage.lang == "en") {
          this.match = option.value.indexOf("Yes") > -1;
        } else {
          this.match = option.value.indexOf("是") > -1;
        }
      }
      for (let i of this.ruleForm.list) {
        if (i.input == item.input) {
          if (item.type == 2) {
            for (let o of i.values) {
              o.checked = o.value == option.value;
            }
          } else {
            for (let o of i.values) {
              if (o.value == option.value) {
                o.checked = checked;
                break;
              }
            }
          }
        }
      }
    },
    logName(e) {
      if (this.keyword) {
        $.getJSON(
          localStorage.getItem("url") +
            "/Personal/Get?projectId=" +
            encodeURIComponent(this.ruleForm.projectId) +
            "&code=" +
            encodeURIComponent(this.keyword),
          (result) => {
            if (result.hasError) {
              this.$message.error(result.message);
              this.clear();
            } else {
              this.ruleForm = { ...result.data };
            }
          }
        );
      }
    },
    prev(type) {
      switch (type) {
        case "ruleForm":
          this.ruleForm.show = true;
          this.cardForm.show = false;
          this.qrcodeForm.show = false;
          break;
        case "cardForm":
          if (this.page > 0) {
            this.elseForm.show = true;
            this.personalForm.show = false;
            this.confirmForm.show = false;
          } else {
            this.cardForm.show = true;
            this.personalForm.show = false;
          }
          break;
        case "personalForm":
          if (this.page > 0) {
            this.page -= 1;
          } else {
            this.personalForm.show = true;
            this.elseForm.show = false;
          }
          break;
        case "elseForm":
          this.elseForm.show = true;
          this.personalForm.show = false;
          this.confirmForm.show = false;
          break;
      }
    },
    next(type) {
      switch (type) {
        case "elseForm":
          this.elseForm.show = true;
          this.personalForm.show = false;
          break;
        case "personalForm":
          this.ruleForm.telNo = "+" + this.ruleForm.area;
          this.ruleForm.phoneNo =
            "+" + this.ruleForm.area + this.ruleForm.phone;
          this.ruleForm.faxNo = "+" + this.ruleForm.area;

          // if (localStorage.lang == "zh" && this.ruleForm.area == 86) {
          //   this.ruleForm.countryArea = "中国";
          //   this.ruleForm.province = this.city;
          //   this.ruleForm.city = this.district;
          // } else if (localStorage.lang == "chs" && this.ruleForm.area == 86) {
          //   this.ruleForm.countryArea = "中國";
          //   this.ruleForm.province = this.city;
          //   this.ruleForm.city = this.district;
          // } else if (localStorage.lang == "en" && this.ruleForm.area == 86) {
          //   this.ruleForm.countryArea = "china";
          // } else if (localStorage.lang == "zh" && this.ruleForm.area == 853) {
          //   this.ruleForm.countryArea = "中国";
          //   this.ruleForm.province = "澳门";
          //   this.ruleForm.city = "澳门";
          // } else if (localStorage.lang == "chs" && this.ruleForm.area == 853) {
          //   this.ruleForm.countryArea = "中國";
          //   this.ruleForm.province = "澳門";
          //   this.ruleForm.city = "澳門";
          // } else if (localStorage.lang == "en" && this.ruleForm.area == 853) {
          //   this.ruleForm.countryArea = "china";
          //   this.ruleForm.province = "macao";
          //   this.ruleForm.city = "macao";
          // } else if (localStorage.lang == "zh" && this.ruleForm.area == 852) {
          //   this.ruleForm.countryArea = "中國";
          //   this.ruleForm.province = "香港";
          //   this.ruleForm.city = "香港";
          // } else if (localStorage.lang == "chs" && this.ruleForm.area == 852) {
          //   this.ruleForm.countryArea = "中國";
          //   this.ruleForm.province = "香港";
          //   this.ruleForm.city = "香港";
          // } else if (localStorage.lang == "en" && this.ruleForm.area == 852) {
          //   this.ruleForm.countryArea = "china";
          //   this.ruleForm.province = "hong kong";
          //   this.ruleForm.city = "hong kong";
          // } else if (localStorage.lang == "zh" && this.ruleForm.area == 886) {
          //   this.ruleForm.countryArea = "中國";
          //   this.ruleForm.province = "台湾";
          //   this.ruleForm.city = this.district;
          // } else if (localStorage.lang == "chs" && this.ruleForm.area == 886) {
          //   this.ruleForm.countryArea = "中國";
          //   this.ruleForm.province = "台湾";
          //   this.ruleForm.city = this.district;
          // } else if (localStorage.lang == "en" && this.ruleForm.area == 886) {
          //   this.ruleForm.countryArea = "china";
          //   this.ruleForm.province = "taiwan";
          // }
          this.personalForm.show = true;
          this.cardForm.show = false;
          break;
      }
    },
    selectFile(e) {
      this.cardForm.card = false;
      const load = this.$loading({
        lock: true,
        text: "loading...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      const file = e.target.files[0];
      if (!file.type.includes("image/")) {
        return;
      }
      const reader = new FileReader();
      reader.onload = (event) => {
        let formData = {
          base64: event.target.result,
        };
        this.$axios
          .post("/UploadCard/Base64", formData)
          .then((res) => {
            load.close();
            if (res.data.hasError == false && res.data.data) {
              let personal = JSON.parse(res.data.data);
              if (personal.data && personal.message == "success") {
                this.personalForm.show = true;
                this.cardForm.show = false;
                this.ruleForm.company = personal.data.company;
                this.ruleForm.email = personal.data.email;
                this.ruleForm.name = personal.data.name;
                this.ruleForm.phoneNo = personal.data.mobile;
                this.ruleForm.faxNo = personal.data.phoneFax;
                this.ruleForm.telNo = personal.data.phoneCompany;
                this.ruleForm.website = personal.data.website;
                this.ruleForm.address1 = personal.data.address;
                this.ruleForm.position = personal.data.title;
              } else {
                this.$message.error(this.$t("register.cardError"));
              }
            } else {
              this.$message.error(this.$t("register.cardError"));
            }
          })
          .catch((error) => {
            console.log(error);
            load.close();
          });
      };
      reader.readAsDataURL(file);
    },
    select(type) {
      switch (type) {
        case "cancel":
          this.cardForm.card = false;
          break;
        case "gallery":
          this.$refs.file.click();
          break;
        case "photograph":
          this.$refs.upload.click();
          break;
        case "edit":
          // this.personalForm.show = true;
          // this.cardForm.show = false;
          this.next("personalForm");
          break;
        case "card":
          this.cardForm.card = true;
          break;
      }
    },
    hangleGoUp() {
      let page = document.getElementsByClassName("main")[0];
      page.scrollIntoView();
    },
    sms() {
      this.isDisabled = true;
      const TIME_COUNT = 60;
      this.count = TIME_COUNT;
      this.ruleForm.code = "";

      let vm = this;
      vm.timer = window.setInterval(() => {
        if (vm.count > 0 && vm.count <= TIME_COUNT) {
          // 倒计时时不可点击
          vm.isDisabled = true;
          // 计时秒数
          vm.count--;
        } else {
          // 倒计时完，可点击
          vm.isDisabled = false;
          // 清空定时器!!!
          clearInterval(vm.timer);
          vm.timer = null;
        }
      }, 1000);
    },
    validator() {
      if (this.ruleForm.phone && this.ruleForm.projectId) {
        this.ruleForm.loading = true;
        this.$axios
          .post("/Invite/Send/", {
            projectId: this.ruleForm.projectId,
            title: this.ruleForm.lang + "_verify",
            isEmail: 0,
            author: "+" + this.ruleForm.area + this.ruleForm.phone,
            content: "+" + this.ruleForm.area,
          })
          .then((res) => {
            this.ruleForm.loading = false;
            if (res.data.hasError == false) {
              this.sms();
              this.ruleForm.code = res.data.data;
              this.$message.success(this.$t("register.smsSuccess"));
            } else {
              this.$message.error(this.$t("register.smsError"));
            }
          })
          .catch((error) => {
            this.ruleForm.loading = false;
            console.log(error);
            this.$message.error(this.$t("register.error"));
          });

        // this.$axios
        //   .post(
        //     "/Validator/",
        //     "phone=" +
        //       this.ruleForm.phone +
        //       "&code=" +
        //       this.ruleForm.projectId +
        //       "&ip=%2B" +
        //       this.ruleForm.area
        //   )
        //   .then((res) => {
        //     this.ruleForm.loading = false;
        //     if (res.data.hasError == false) {
        //       this.$message.success(this.$t("register.smsSuccess"));
        //     } else {
        //       this.$message.error(this.$t("register.smsError"));
        //     }
        //   })
        //   .catch((error) => {
        //     this.ruleForm.loading = false;
        //     console.log(error);
        //     this.$message.error(this.$t("register.error"));
        //   });
      } else {
        this.$message.error(this.$t("register.phone"));
      }
    },
    clear() {
      this.ruleForm.openId = "";
      this.ruleForm.idCard = "";
      this.ruleForm.personalId = "";
      this.ruleForm.name = "";
      this.ruleForm.sex = "";
      this.ruleForm.company = "";
      this.ruleForm.companyEn = "";
      this.ruleForm.postcode = "";
      this.ruleForm.countryArea = "";
      this.ruleForm.province = "";
      this.ruleForm.city = "";
      this.ruleForm.address1 = "";
      this.ruleForm.address = "";
      this.ruleForm.position = "";
      this.ruleForm.telNo = "";
      this.ruleForm.phoneNo = "";
      this.ruleForm.email = "";
      this.ruleForm.documentId = "";
      this.ruleForm.phone = "";
      this.ruleForm.code = "";
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (formName == "ruleForm") {
            this.rulesPersonal.loading = true;
            this.$axios
              .get(
                "/Validator/" +
                  "+" +
                  this.ruleForm.area +
                  this.ruleForm.phone +
                  "/" +
                  this.ruleForm.code
              )
              .then((res) => {
                if (location.href.indexOf("127.0.0.1") == -1) {
                  if (res.data.hasError) {
                    this.$message.error(this.$t("register.validatorError"));
                    return;
                  } else {
                    this.ruleForm.show = false;
                    this.cardForm.show = true;
                  }
                } else {
                  this.ruleForm.show = false;
                  this.cardForm.show = true;
                }
                this.rulesPersonal.loading = false;
                this.$axios
                  .get(
                    "/Personal/" +
                      this.ruleForm.type +
                      "/" +
                      this.ruleForm.projectId +
                      "/+" +
                      this.ruleForm.area +
                      this.ruleForm.phone +
                      "/"
                  )
                  .then((res) => {
                    if (res.data.data) {
                      this.ruleForm.show = false;
                      this.qrcodeForm.show = true;
                      this.ruleForm.name = res.data.data.name;
                      this.ruleForm.company = res.data.data.company;
                      this.ruleForm.position = res.data.data.position;
                      this.qrcodeForm.qrcode =
                        axios.defaults.baseURL.substr(
                          0,
                          axios.defaults.baseURL.length - 4
                        ) +
                        "/qrcode/" +
                        res.data.data.code;
                    } else {
                    }
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              })
              .catch((error) => {
                this.rulesPersonal.loading = false;
                console.log(error);
                this.$message.error(this.$t("register.error"));
              });
          } else if (formName == "personalForm") {
            if (this.page > 0) {
              for (let i = this.personalList.length - 1; i >= 0; i--) {
                if (this.page != i) {
                  if (this.personalList[i].phoneNo == this.ruleForm.phoneNo) {
                    this.$message.error(this.$t("register.rePhoneNo"));
                    return;
                  } else if (
                    "+" + this.ruleForm.area ==
                    this.ruleForm.phoneNo
                  ) {
                    this.$message.error(
                      this.$t("register.input") + this.$t("register.phoneNo")
                    );
                    return;
                  } else if (
                    this.personalList[i].email == this.ruleForm.email
                  ) {
                    this.$message.error(this.$t("register.reEmail"));
                    return;
                  }

                  for (let item of this.ruleForm.list) {
                    item.value = "";
                    switch (item.type) {
                      case 0:
                        if (item.values && item.values.length > 0) {
                          let flag = true;
                          for (let option of item.values) {
                            if (option.checked) {
                              flag = false;
                              if (item.value) item.value += "|" + option.value;
                              else item.value = option.value;
                            }
                          }
                          if (item.required == 1 && flag && this.match) {
                            this.$message.error(item.title);
                            return;
                          }
                        }
                        break;
                      case 2:
                      case 4:
                        if (item.values) {
                          let flag = true;
                          for (let option of item.values) {
                            if (option.checked) {
                              flag = false;
                              if (item.value) item.value += "|" + option.value;
                              else item.value = option.value;
                            }
                          }
                          if (item.required == 1 && flag) {
                            this.$message.error(item.title);
                            return;
                          } else if (
                            item.values[item.values.length - 1].checked &&
                            item.value &&
                            item.type == 4 &&
                            item.validator == "" &&
                            item.value.indexOf(
                              item.values[item.values.length - 1].value
                            ) > -1
                          ) {
                            this.$message.error(
                              item.title +
                                ";" +
                                item.values[item.values.length - 1].value
                            );
                            return;
                          }
                        }
                        break;
                      case 8:
                        if (item.required == 1 && !item.value) {
                          this.$message.error(item.title);
                        }
                        break;
                    }
                  }
                }
              }
            }
            if (this.ruleForm.name == "") {
              this.$message.error(
                this.$t("register.input") + this.$t("register.name")
              );
              return;
            }
            this.ruleForm.verify = 0;
            this.personalList[this.page] = JSON.parse(
              JSON.stringify(this.ruleForm)
            );
            this.save();
          } else if (formName == "elseForm") {
            this.flag = false;
            this.total = 0;
            for (let item of this.ruleForm.list) {
              item.value = "";
              switch (item.type) {
                case 0:
                  if (item.values && item.values.length > 0) {
                    let flag = true;
                    for (let option of item.values) {
                      if (option.checked) {
                        flag = false;
                        if (item.value) item.value += "|" + option.value;
                        else item.value = option.value;
                      }
                    }
                    if (item.required == 1 && flag && this.match) {
                      this.$message.error(item.title);
                      return;
                    }
                  }
                  break;
                case 2:
                case 4:
                  if (item.values) {
                    let flag = true;
                    for (let option of item.values) {
                      if (option.checked) {
                        flag = false;
                        if (item.value) item.value += "|" + option.value;
                        else item.value = option.value;
                      }
                    }
                    if (item.required == 1 && flag) {
                      this.$message.error(item.title);
                      return;
                    } else if (
                      item.values[item.values.length - 1].checked &&
                      item.value &&
                      item.type == 4 &&
                      item.validator == "" &&
                      item.value.indexOf(
                        item.values[item.values.length - 1].value
                      ) > -1
                    ) {
                      this.$message.error(
                        item.title +
                          ";" +
                          item.values[item.values.length - 1].value
                      );
                      return;
                    }
                  }
                  break;
                case 8:
                  if (item.required == 1 && !item.value) {
                    this.$message.error(item.title);
                  }
                  break;
              }
              if (
                item.input == "registers" &&
                item.value &&
                ((item.value.indexOf("是") > -1 && localStorage.lang != "en") ||
                  (item.value.indexOf("Yes") > -1 && localStorage.lang == "en"))
              ) {
                this.flag = true;
              } else if (item.input == "persons" && this.flag) {
                this.total = item.validator;
                item.value = item.validator;
              } else if (item.item == "match") {
                this.ruleForm.disabled =
                  (item.value.indexOf("是") > -1 &&
                    localStorage.lang != "en") ||
                  (item.value.indexOf("Yes") > -1 && localStorage.lang == "en")
                    ? 1
                    : 0;
              }
            }
            if (this.flag) {
              this.ruleForm.verify = 1;
              this.personalList[this.page] = JSON.parse(
                JSON.stringify(this.ruleForm)
              );
              if (this.page < this.total) {
                this.elseForm.show = false;
                this.personalForm.show = true;
                if (this.personalList.length <= this.total) {
                  this.clear();
                }
                this.page++;
                this.hangleGoUp();
              } else {
                this.confirmForm.show = true;
                this.elseForm.show = false;
                this.personalForm.show = false;
              }
            } else {
              this.personalList[this.page] = JSON.parse(
                JSON.stringify(this.ruleForm)
              );
              this.save();
            }
          } else {
            this.personalList[this.page] = JSON.parse(
              JSON.stringify(this.ruleForm)
            );
            this.save();
          }
        }
      });
    },
    save() {
      this.confirmForm.loading = true;
      let i = 0;
      this.ruleForm = this.personalList[0];
      for (let item of this.personalList) {
        if (item.area == 853) {
          item.countryArea = "MACAO";
        } else if (item.area == 86) {
          item.countryArea = "CHINA";
        }
        if (i == 0) {
          item.verify = 1;
        } else if (this.flag == false) {
          break;
        }
        if (item.personalId != "") {
          this.$axios
            .put("/Personal/" + item.personalId, item)
            .then((result) => {
              if (result.data.hasError) {
                this.$message.error(this.$t("register.error"));
              } else {
                this.clear();
                window.open(
                  localStorage.getItem("url") +
                    "/printer/" +
                    result.data.data.documentId
                );
              }
            })
            .catch((error) => {
              this.confirmForm.loading = false;
              console.log(error);
            });
        } else {
          this.$axios
            .post("/Personal/", item)
            .then((result) => {
              if (result.data.hasError) {
                this.$message.error(result.data.message);
              } else {
                this.clear();
                window.open(
                  localStorage.getItem("url") +
                    "/printer/" +
                    result.data.data.documentId
                );
              }
            })
            .catch((error) => {
              this.confirmForm.loading = false;
              console.log(error);
            });
        }
        i++;
      }
      if (this.flag) {
        setTimeout(() => {
          try {
            this.$axios
              .post("/Invite/SendList/", {
                projectId: this.ruleForm.projectId,
                title: this.ruleForm.lang + "_email_confirm",
                isEmail: 1,
                content: JSON.stringify(this.personalList),
              })
              .then((res) => {
                console.log(res);
              });
          } catch (error) {
            console.log(error);
          }
        }, 3000);
      }
    },
    selectLang(val) {
      localStorage.lang = this.ruleForm.lang;
      this.$i18n.locale = this.ruleForm.lang;
      this.init();
      //this.reloadPage();
    },
    init() {
      if (this.ruleForm.lang != "en") {
        this.allarea = this.ruleForm.lang == "chs" ? allChs : allarea;
        //item.name = pinyin.getFullChars(item.name);
      }
      this.rules = {
        countryArea: [
          {
            required: true,
            message:
              this.$t("register.input") + this.$t("register.countryArea"),
            trigger: "change",
          },
        ],
        phone: [
          {
            required: true,
            message: this.$t("register.phone"),
            trigger: "change",
          },
        ],
        code: [
          {
            required: true,
            message: this.$t("register.code"),
            trigger: "change",
          },
        ],
      };
      this.rulesPersonal = {
        company: [
          {
            required: this.ruleForm.lang != "en",
            validator: this.validateComapny,
            message: this.$t("register.input") + this.$t("register.company"),
            trigger: "change",
          },
        ],
        companyEn: [
          {
            required: this.ruleForm.lang == "en",
            validator: this.validateComapny,
            message: this.$t("register.input") + this.$t("register.companyEn"),
            trigger: "change",
          },
        ],
        countryArea: [
          {
            required: false,
            message:
              this.$t("register.input") + this.$t("register.countryArea"),
            trigger: "change",
          },
        ],
        province: [
          {
            required: false,
            message: this.$t("register.input") + this.$t("register.province"),
            trigger: "change",
          },
        ],
        city: [
          {
            required: false,
            message: this.$t("register.input") + this.$t("register.city"),
            trigger: "change",
          },
        ],
        phoneNo: [
          {
            required: false,
            message: this.$t("register.input") + this.$t("register.phoneNo"),
            trigger: "change",
          },
        ],
        email: [
          {
            required: false,

            message: this.$t("register.input") + this.$t("register.email"),
            trigger: "change",
          },
          {
            type: "email",
            message: this.$t("register.emailError"),
            trigger: "change",
          },
        ],
        name: [
          {
            required: true,
            message: this.$t("register.input") + this.$t("register.name"),
            trigger: "change",
          },
        ],
        address1: [
          {
            required: false,
            message: this.$t("register.input") + this.$t("register.address1"),
            trigger: "change",
          },
        ],
        // telNo: [
        //   {
        //     required: true,
        //     message: this.$t("register.input")+this.$t("register.telNo"),
        //     trigger: "change",
        //   },
        // ],
        phoneNo: [
          {
            required: false,
            message: this.$t("register.input") + this.$t("register.phoneNo"),
            trigger: "change",
          },
        ],
        sex: [
          {
            required: true,
            message: this.$t("register.input") + this.$t("register.sex"),
            trigger: "change",
          },
        ],
      };
      this.sexs = [];
      this.restaurants = [];

      switch (this.ruleForm.lang) {
        case "zh":
          this.sexs.push({ value: "先生", label: "先生" });
          this.sexs.push({ value: "女士", label: "女士" });
          this.sexs.push({ value: "小姐", label: "小姐" });
          this.sexs.push({ value: "博士", label: "博士" });
          for (let item of area) {
            this.restaurants.push({ value: item.zh, code: item.code });
          }
          break;
        case "en":
          this.sexs.push({ value: "Mr", label: "Mr" });
          this.sexs.push({ value: "Mrs", label: "Mrs" });
          this.sexs.push({ value: "Miss", label: "Miss" });
          this.sexs.push({ value: "Dr", label: "Dr" });
          for (let item of area) {
            this.restaurants.push({ value: item.en, code: item.code });
          }
          break;
        case "chs":
          this.sexs.push({ value: "先生", label: "先生" });
          this.sexs.push({ value: "女士", label: "女士" });
          this.sexs.push({ value: "小姐", label: "小姐" });
          this.sexs.push({ value: "博士", label: "博士" });
          for (let item of area) {
            this.restaurants.push({ value: item.chs, code: item.code });
          }
          break;
      }
      this.$axios
        .get("/Property/register/" + this.$route.query.id)
        .then((res) => {
          if (res.data.data) {
            this.list = [...res.data.data];
            this.list = this.list.sort((a, b) => {
              return a.indexNo - b.indexNo;
            });
            this.ruleForm.list = [];
            for (let item of this.list) {
              switch (item.type) {
                case 0:
                case 2:
                case 4:
                  this.ruleForm.list.push(item);
                  item.values = [];
                  item.value = "";
                  item.validator = "";
                  switch (this.ruleForm.lang) {
                    case "en":
                      item.title = item.englishName;
                      if (item.englishOption) {
                        for (let str of item.englishOption.split("|")) {
                          item.values.push({ checked: false, value: str });
                        }
                      }
                      break;
                    case "chs":
                      item.title = item.traditionalName;
                      if (item.traditionalOptions) {
                        for (let str of item.traditionalOptions.split("|")) {
                          item.values.push({ checked: false, value: str });
                        }
                      }
                      break;
                    default:
                      item.title = item.name;
                      if (item.options) {
                        for (let str of item.options.split("|")) {
                          item.values.push({ checked: false, value: str });
                        }
                      }
                      break;
                  }
                  break;
                case 8:
                  this.ruleForm.list.push(item);
                  if (item.input == "persons") {
                    item.value = 1;
                  }
                  switch (this.ruleForm.lang) {
                    case "en":
                      item.title = item.englishName;
                      break;
                    case "chs":
                      item.title = item.traditionalName;
                      break;
                    default:
                      item.title = item.name;
                      break;
                  }
                  break;
              }
            }
            if (this.ruleForm.projectId.length > 0) {
              this.$axios
                .post("/Invite/Get/", {
                  projectId: this.ruleForm.projectId,
                  title: localStorage.lang,
                  isEmail: 2,
                })
                .then((res) => {
                  if (res.data.data.content) {
                    this.bannerMoblie = res.data.data.content;
                  }
                });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  created() {
    this.$axios
      .get("/Register/Project/" + this.ruleForm.projectId)
      .then((resp) => {
        if (resp.data.data) {
          let id = this.$route.query.id
            ? this.$route.query.id
            : resp.data.data[0].registerId;

          // if (localStorage.area) {
          //   this.ruleForm.area = localStorage.area;
          // }
          // if (localStorage.code) {
          //   this.ruleForm.code = localStorage.code;
          // }
          // if (localStorage.countryArea) {
          //   this.ruleForm.countryArea = localStorage.countryArea;
          // }
          // if (localStorage.phone) {
          //   this.ruleForm.phone = localStorage.phone;
          // }
          this.$axios
            .get(`/Register/${id}`)
            .then((res) => {
              if (res.data.data) {
                if (res.data.data.bannerMoblie) {
                  this.bannerMoblie = res.data.data.bannerMoblie;
                }
                let dt = { ...res.data.data };
                this.banner = res.data.data.banner;
                this.ruleForm.type = res.data.data.type;
                this.ruleForm.registerId = res.data.data.registerId;
                this.ruleForm.documentTypeId = dt.documentTypeId;

                this.$axios
                  .get(`/Project/${this.ruleForm.projectId}`)
                  .then((result) => {
                    if (result.data.data) {
                      this.banner = result.data.data.banner
                        ? result.data.data.banner
                        : result.data.data.url;
                    }
                  })
                  .catch((error) => {
                    console.log(error);
                  });

                this.getDocumentType();
                document.title = res.data.data.name;
              }
            })
            .catch((error) => {
              console.log(error);
            });

          if (this.$route.query.lang) {
            this.ruleForm.lang = this.$route.query.lang;
            localStorage.lang = this.ruleForm.lang;
            this.$i18n.locale = this.ruleForm.lang;
          } else {
            localStorage.lang = "chs";
          }
          this.init();
        }
      });
  },
  mounted() {},
  // beforeMount() {
  //   this.updateCity();
  //   this.updateDistrict();
  // },
  // computed: {},
  // watch: {
  //   prov() {
  //     this.updateCity();
  //     this.updateDistrict();
  //   },
  //   city() {
  //     this.updateDistrict();
  //   },
  // },
};
</script>
<style  lang="scss" scoped>
.main {
  padding-left: 0 !important;
  width: 50%;
  margin-left: 25%;
  max-width: 50%;
  background: #fff;
}
.footer {
  position: fixed;
  bottom: 10px;
  height: 60px;
  width: 50%;
  text-align: center;
  a {
    font-size: 10px;
  }
}
.register-page {
  .question-select {
    height: 20px;
    font-size: 16px;
  }
  .question-select select {
    border-radius: 5px;
    box-shadow: 0 0 5px #ccc;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    border: none;
    outline: none;
    height: 100%;
    padding: 0 20px;
    color: #333;
  }
  span {
    font-size: 16px;
  }
  .el-checkbox.is-bordered {
    height: auto !important;
    vertical-align: middle !important;
    width: 100%;
  }
  .el-radio--medium.is-bordered {
    height: auto !important;
    vertical-align: middle !important;
    width: 100%;
    padding-bottom: 10px !important;
  }
  body {
    max-width: 100%;
  }
  .el-input__inner {
    height: 42px !important;
  }
  .flag-list-box {
    background: #fff !important;
  }
  .el-radio__label {
    white-space: normal;
    word-wrap: break-word;
    overflow: hidden;
    vertical-align: middle !important;
  }
  .el-checkbox__label {
    white-space: normal;
    word-wrap: break-word;
    overflow: hidden;
    vertical-align: middle !important;
  }
  .foot {
    height: 100%;
    width: 100%;
    z-index: 999;
    position: fixed;
    display: flex;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5) !important;
  }
  .qrcode {
    z-index: 2;
    position: absolute;
    width: 80%;
    padding-left: 10%;
    top: 3.3rem;
    font-size: 4px;
    text-align: left;
  }
  .el-steps {
    margin-top: 15px;
  }
  .el-step__title {
    font-size: 14px !important ;
    line-height: 20px !important ;
    font-weight: 400 !important;
  }
  .el-cascader-menu {
    min-width: 0 !important;
  }
  .el-upload--text {
    display: none;
  }
  .photograph {
    position: fixed;
    bottom: 122px;
    line-height: 60px;
    height: 60px;
    width: 100%;
    background: #ffffff;
    opacity: 1;
    border-radius: 20px 20px 0px 0px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #161616;
    text-align: center;
    vertical-align: middle;
  }
  input[type="file"] {
    opacity: 0;
    display: none;
  }
  .gallery {
    line-height: 60px;
    height: 60px;
    position: fixed;
    bottom: 61px;
    width: 100%;
    background: #ffffff;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #161616;
    text-align: center;
    vertical-align: middle;
  }
  .cancel {
    position: fixed;
    bottom: 0;
    line-height: 60px;
    width: 100%;
    background: #ffffff;
    opacity: 1;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #161616;
    text-align: center;
    vertical-align: middle;
  }
  .tel-container {
    display: flex;
    align-items: center;
    background-color: #fbfbfb;
    border-radius: 5px;
  }
  p {
    margin-left: 20px;
  }
  .next {
    float: right;
  }
  .lang {
    width: 120px;
    float: right;
  }
  .card {
    display: inline-block;
    float: left;
    width: 120px;
    height: 120px;
    background: rgb(2, 113, 2);
    box-shadow: 2px 2px 5px rgba(2, 37, 104, 0.15);
    opacity: 1;
    border-radius: 21px;
  }
  .flag-list-box {
    background: #fff;
  }
  .card p {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 15px;
    color: #ffffff;
    opacity: 1;
    margin-left: 0px;
    margin-top: 10px;
    text-align: center;
  }
  .card img {
    margin-left: 32px;
    margin-top: 25px;
    width: 56px;
  }
  .edit p {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 15px;
    color: #ffffff;
    opacity: 1;
    margin-left: 0px;
    text-align: center;
  }
  .edit img {
    margin-left: 32px;
    margin-top: 22px;
    width: 56px;
  }
  .edit {
    float: right;
    display: inline-block;
    width: 120px;
    height: 120px;
    background: #3578fa;
    box-shadow: 2px 2px 5px rgba(2, 37, 104, 0.15);
    opacity: 1;
    border-radius: 21px;
  }
  form {
    padding-left: 6%;
    margin-top: 30px;
    margin-bottom: 30px;
    width: 88%;
    height: auto;
  }
  img {
    width: 100%;
  }
  h2 {
    text-align: center;
    font-size: 20px;
  }
  * {
    font-size: 14px;
  }
}
</style>
